import type React from 'react';

interface FacebookIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function FacebookIcon({ size = 24, ...props }: FacebookIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Facebook">
        <path
          id="Vector"
          d="M13.75 1.75H2.25C1.97344 1.75 1.75 1.97344 1.75 2.25V13.75C1.75 14.0266 1.97344 14.25 2.25 14.25H13.75C14.0266 14.25 14.25 14.0266 14.25 13.75V2.25C14.25 1.97344 14.0266 1.75 13.75 1.75ZM13.25 13.25H10.3734V9.40938H11.9984L12.2422 7.52344H10.3734V6.31875C10.3734 5.77187 10.525 5.4 11.3078 5.4H12.3062V3.7125C12.1328 3.68906 11.5406 3.6375 10.85 3.6375C9.40938 3.6375 8.42344 4.51719 8.42344 6.13125V7.52187H6.79531V9.40781H8.425V13.25H2.75V2.75H13.25V13.25Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
